import { COOKIE_DOMAIN } from './constants.js'

/**
 * Cookie 操作工具
 */
export function setCookie(name, value, options = {}) {
  const defaultOptions = {
    path: '/',
    domain: COOKIE_DOMAIN,
    expires: undefined,
    ...options
  }

  let cookieValue = typeof value === 'object' ? JSON.stringify(value) : String(value)
  let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(cookieValue)}`

  if (defaultOptions.expires) {
    if (typeof defaultOptions.expires === 'number') {
      const date = new Date()
      date.setDate(date.getDate() + defaultOptions.expires)
      cookieStr += `; expires=${date.toUTCString()}`
    } else if (defaultOptions.expires instanceof Date) {
      cookieStr += `; expires=${defaultOptions.expires.toUTCString()}`
    }
  }

  if (defaultOptions.path) {
    cookieStr += `; path=${defaultOptions.path}`
  }

  if (defaultOptions.domain) {
    cookieStr += `; domain=${defaultOptions.domain}`
  }

  document.cookie = cookieStr
}

export function getCookie(name) {
  const cookies = document.cookie.split('; ')
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=')
    if (decodeURIComponent(cookieName) === name) {
      const decodedValue = decodeURIComponent(cookieValue)
      try {
        return JSON.parse(decodedValue)
      } catch {
        return decodedValue
      }
    }
  }
  return null
}

export function removeCookie(name) {
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${COOKIE_DOMAIN}`
}